<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/experts">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.title}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius" v-if="isLoaded">
          <div class="column caption">
            <p>Редактирование эксперта</p>
          </div>
          <div class="column">
            <div class="content">
              <new-input title="Имя автора" name="title"></new-input>
              <edit-file class="short align-top" use-case="cover" v-if="isLoaded" title="Изображение"
                         name="img"></edit-file>
              <new-input title="URL" name="url"></new-input>
              <new-input title="Alt" name="seo_alt"></new-input>
              <new-input title="Email" name="mail"></new-input>
              <new-input title="Facebook" name="facebook"></new-input>
              <new-input title="Вконтакте" name="vk"></new-input>
              <new-input title="YouTube" name="youTube"></new-input>
              <new-input title="Live Journal" name="liveJournal"></new-input>
              <new-input title="Одноклассники" name="ok"></new-input>
              <new-input title="Skype" name="skype"></new-input>
            </div>
          </div>
        </div>
        <div class="folder radius" v-if="isLoaded">
          <div class="column caption">
            <p>СЕО настройки</p>
          </div>
          <div class="column">
            <div class="content">
              <new-input title="Название страницы" name="seo_title"></new-input>
              <new-text-area title="Описание" name="seo_desc"></new-text-area>
              <new-text-area title="Ключевые слова" name="seo_key"></new-text-area>
            </div>
          </div>
        </div>
        <div class="folder radius">
          <div class="column caption">
            <p>Описание эксперта</p>
          </div>
          <div class="column">
            <div class="content">
              <div :class="{saved: savedFields.hasOwnProperty('text') && !changedText}">
                <textarea id="editor" name="editor" v-model="text"></textarea>
                <add-image v-if="isLoaded"/>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import AddImage from '@/components/edit-form/AddImage'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data () {
      return {
        isLoaded: false,
        editorInstance: '',
        text: '',
        changedText: false,
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      ...mapState([
        'item',
        'copyItem',
        'textContent',
        'savedFields'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId() {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset',
        'updateNews'
      ]),
      ...mapMutations([
        'resetModule',
        'setFileExtensions',
        'setItemField',
        'setEditorInstance'
      ]),
      onSubmit () {
        this.setItemField({fieldName: 'text', value: this.text})
        let object = {
          mail: this.item.mail,
          facebook: this.item.facebook,
          ok: this.item.ok,
          liveJournal: this.item.liveJournal,
          skype: this.item.skype,
          youTube: this.item.youTube,
          vk: this.item.vk,
        }
        this.edit({
          title: this.item.title,
          object: JSON.stringify(object),
          subtext: this.item.subtext,
          seo_title: this.item.seo_title,
          seo_desc: this.item.seo_desc,
          seo_key: this.item.seo_key,
          seo_alt: this.item.seo_alt,
          img: this.item.img,
          text: this.editor.getData(),
          url: this.item.url
        })
          .then(data => {
            console.log('ok')
            this.updateNews({
              title: data.article.title,
              id: data.article.id,
              newsId: data.lastNews.id,
              section_id: this.parentId.experts,
              is_active: this.item.is_active,
              url: {
                categoryId: null,
                articleUrl: data.article.url
              },
              img: data.article.img,
              subtext: data.article.seo_desc
            })
          })
      }
    },
    mounted () {
    },
    created () {
      this.resetModule()
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Эксперты',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование автора',
          seo: 'SEO информация',
          options: 'Прочие настройки',
        },
        errors: {
          title: {message: 'Введите название курса', hasError: false},
          text: {message: 'Введите текст', hasError: false},
          mail: {isNullable: true, hasError: false},
          facebook: {isNullable: true, hasError: false},
          ok: {isNullable: true, hasError: false},
          liveJournal: {isNullable: true, hasError: false},
          skype: {isNullable: true, hasError: false},
          youTube: {isNullable: true, hasError: false},
          vk: {isNullable: true, hasError: false},
          seo_alt: {isNullable: true, hasError: false},
          seo_title: {message: 'Введите название страницы', isNullable: true, hasError: false},
          seo_desc: {message: 'Напишите краткое описание', isNullable: true, hasError: false},
          seo_key: {message: 'Напишите ключевые слова', isNullable: true, hasError: false},
          img: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false},
          url: {message: 'Введите url страницы', isNullable: true, hasError: false}
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.content
      }).then((response) => {
        this.text = response.text ? response.text : ''
        for (let key in response.object) {
          if (response.object.hasOwnProperty(key)) {
            this.setItemField({fieldName: key, value: response.object[key]})
          }
        }
        this.isLoaded = true
        this.editor = CKEDITOR.replace('editor')
        this.editor.on('change', () => {
          this.changedText = true
        })
        this.setEditorInstance(this.editor)
      })
    },
    components: {
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload,
      AddImage
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/experts/pages/Edit.vue